<div class="general-error">
  <div class="general-error__image"></div>
  <p class="general-error__text">{{ errorMessage }}</p>
</div>